module.exports = __webpack_public_path__ + "static/media/pen-square.d748d166.svg";